module.exports = __webpack_public_path__ + "static/media/assa-small-street-selected.9c865681.svg";